import _ from 'lodash';

export const setFormValue = (item, router, location, getDetail, setDetail) => {
  if (!_.isUndefined(router.params.id)) {
    const { id } = router?.params || {};
    const parsedId = parseInt(id, 10);
    const list = Array.isArray(item) 
      ? item 
      : Array.isArray(item?.list) 
        ? item.list 
        : item?.list && typeof item.list === 'object' 
          ? Object.values(item.list)
          : [];

    const values = (Array.isArray(list) && !Number.isNaN(parsedId))
      ? list.filter(i => i && Number(i.id) === parsedId)
      : [];
    if (values.length === 1) {
      setDetail(values[0]);
    } else {
      getDetail(router.params.id);
    }
  } else {
    if (!_.isUndefined(location.state)) {
      setDetail(location.state);
    }
  }
};

export const create_or_update = (router, values, create, update) => {
  if (_.isUndefined(router.params.id)) {
    create(values, router);
  } else {
    values['id'] = router.params.id;
    update(values, router);
  }
};
